module.exports = __webpack_public_path__ + "img/PPTX.65f72c8a.png";